/* Safari (risparmio energetico o "non riprodurre automaticamente") blocca l'avvio da solo:
   niente tasto play di sistema, il video resta sul fotogramma e parte al primo tocco/clic/tasto. */
(function(){
  if (window.nmPlay) return;
  var fermi = [];
  var st = document.createElement('style');
  st.textContent = 'video::-webkit-media-controls-start-playback-button,video::-webkit-media-controls-overlay-play-button{display:none!important;-webkit-appearance:none!important;opacity:0!important}video::-webkit-media-controls-panel{display:none!important}';
  (document.head || document.documentElement).appendChild(st);
  function prova(v){
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function(){ if (fermi.indexOf(v) < 0) fermi.push(v); });
  }
  function riprova(){ var l = fermi; fermi = []; l.forEach(function(v){ if (v.isConnected) prova(v); }); }
  ['pointerup','touchend','mousedown','keydown'].forEach(function(e){ document.addEventListener(e, riprova, { capture: true, passive: true }); });
  window.nmPlay = prova;
})();
/* Landing biglietto Nemico: righe che riempiono la larghezza, quantità e totale, video che parte */
(function () {
  var root = document.getElementById('nmb');
  if (!root) return;

  /* le righe grandi si misurano e si adattano alla larghezza, con qualsiasi font */
  function fit() {
    root.querySelectorAll('.nmb-fit').forEach(function (box) {
      var inner = box.querySelector('.nmb-fit-in');
      if (!inner) return;
      var w = box.clientWidth;
      if (!w) return;
      inner.style.fontSize = '100px';
      var iw = inner.getBoundingClientRect().width;
      if (iw > 0) inner.style.fontSize = (Math.floor(100 * w / iw * 100) / 100) + 'px';
    });
  }
  fit();
  window.addEventListener('resize', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (window.ResizeObserver) { var b = root.querySelector('.nmb-fit'); if (b) new ResizeObserver(fit).observe(b); }

  /* il video deve partire da solo e in loop */
  root.querySelectorAll('video').forEach(function (v) {
    v.loop = true; window.nmPlay(v);
  });

  /* quantità e totale */
  var qty = document.getElementById('nmb-qty'), out = document.getElementById('nmb-q'), tot = document.getElementById('nmb-tot');
  if (qty) {
    var max = Math.max(1, parseInt(qty.dataset.max, 10) || 1);
    var prezzo = (parseFloat(qty.dataset.prezzo) || 0) / 100; /* Liquid dà il prezzo in centesimi */
    var meno = root.querySelector('[data-q="-"]'), piu = root.querySelector('[data-q="+"]');
    function euro(n) {
      var s = (Math.round(n * 100) / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
      return '€' + s;
    }
    function set(n) {
      n = Math.min(max, Math.max(1, n));
      qty.value = n; out.textContent = n;
      if (tot) tot.textContent = euro(prezzo * n);
      if (meno) meno.disabled = n <= 1;
      if (piu) piu.disabled = n >= max;
    }
    if (meno) meno.addEventListener('click', function () { set(parseInt(qty.value, 10) - 1); });
    if (piu) piu.addEventListener('click', function () { set(parseInt(qty.value, 10) + 1); });
    set(1);
  }

  /* il tasto in apertura scorre ai lotti senza salto secco */
  var cta = root.querySelector('.nmb-cta');
  if (cta) cta.addEventListener('click', function (e) {
    var t = document.getElementById('biglietti');
    if (t && t.scrollIntoView) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
